import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const styles = [{
  name: 'Classic Shaker',
  finish: 'Espresso Wood',
  image: 'https://images.unsplash.com/photo-1588854337236-6889d631faa8?auto=format&fit=crop&q=80&w=800'
}, {
  name: 'Modern Slab',
  finish: 'Matte Charcoal',
  image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&q=80&w=800'
}, {
  name: 'Raised Panel',
  finish: 'Copper Brown',
  image: 'https://cdn.magicpatterns.com/uploads/2jzrztghwBLT5wfH6Veasn/image.png'
}, {
  name: 'Minimalist',
  finish: 'Alabaster White',
  image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&q=80&w=800'
}];
export function Showroom() {
  return <section className="py-24 px-6 bg-white" data-id="element-156">
      <div className="max-w-7xl mx-auto" data-id="element-157">
        <div className="text-center mb-16" data-id="element-158">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-159">
            Material & Door Showroom
          </h2>
          <p className="text-charcoal/60" data-id="element-160">
            Precision-cut styles for every architectural aesthetic.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8" data-id="element-161">
          {styles.map((style, idx) => <motion.div key={idx} className="group relative flex flex-col border-3 border-charcoal overflow-hidden" whileHover={{
          y: -8
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} data-id="element-162">
              <div className="aspect-[4/5] overflow-hidden bg-alabaster" data-id="element-163">
                <motion.img src={style.image} alt={style.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-164" />
                {/* Micro-zoom indicator */}
                <div className="absolute inset-0 bg-charcoal/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center pointer-events-none" data-id="element-165">
                  <div className="bg-white/90 px-4 py-2 text-xs font-bold uppercase tracking-widest border-2 border-charcoal" data-id="element-166">
                    Zoom for Detail
                  </div>
                </div>
              </div>
              <div className="p-6 bg-white border-t-3 border-charcoal flex-grow flex flex-col justify-between" data-id="element-167">
                <div data-id="element-168">
                  <h3 className="text-xl font-bold mb-1" data-id="element-169">{style.name}</h3>
                  <p className="text-sm text-charcoal/40 mb-6" data-id="element-170">
                    {style.finish}
                  </p>
                </div>
                <Link to="/get-quote" className="w-full py-3 border-2 border-charcoal text-xs font-bold uppercase tracking-widest hover:bg-charcoal hover:text-white transition-all text-center" data-id="element-171">
                  Select Style for Quote
                </Link>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}